import {
    LOGIN,
    LOGIN_ERROR,
    LOGIN_SUCCESS,
    LOGOUT,
    LOGOUT_ERROR,
    LOGOUT_SUCCESS
} from '../constants/authConstants';


const initialState = {
    loading: false,
    success: false,
    logged: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
};


function authReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'type': action.type

            });
        case LOGIN_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'logged': false,
                'error': action,
                'type': action.type
            });
        case LOGIN_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'logged': true,
                'userName': action.data.userName,
                'givenName': action.data.given_name,
                'familyName': action.data.family_name,
                'superAdmin': action.data.isSuperAdmin,
                'error': '',
                'type': action.type
            });
        case LOGOUT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'type': action.type

            });
        case LOGOUT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'logged': false,
                'error': action,
                'type': action.type
            });
        case LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'logged': false,
                'error': '',
                'type': action.type
            });
        default:
            return state;
    }
};

export default authReducer